import { LeafletProvider, createContainerComponent, createControlHook, createElementHook, createElementObject, extendContext, useLeafletContext } from '@react-leaflet/core';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
export const useLeafletLayersControlElement = createElementHook(function createLayersControl({ children: _c , ...options }, ctx) {
    const control = new window.L.control.layers(undefined, undefined, options);
    return createElementObject(control, extendContext(ctx, {
        layersControl: control
    }));
}, function updateLayersControl(control, props, prevProps) {
    if (props.collapsed !== prevProps.collapsed) {
        if (props.collapsed === true) {
            control.collapse();
        } else {
            control.expand();
        }
    }
});
export const useLeafletLayersControl = createControlHook(useLeafletLayersControlElement);
// @ts-ignore
export const LeafletLayersControl = createContainerComponent(useLeafletLayersControl);
export function createLeafletControlledLayer(addLayerToControl) {
    return function ControlledLayer(props) {
        const parentContext = useLeafletContext();
        const propsRef = useRef(props);
        const [layer, setLayer] = useState(null);
        const { layersControl , map  } = parentContext;
        const addLayer = useCallback((layerToAdd)=>{
            if (layersControl != null) {
                if (propsRef.current.checked) {
                    map.addLayer(layerToAdd);
                }
                addLayerToControl(layersControl, layerToAdd, propsRef.current.name);
                setLayer(layerToAdd);
            }
        }, [
            layersControl,
            map
        ]);
        const removeLayer = useCallback((layerToRemove)=>{
            layersControl?.removeLayer(layerToRemove);
            setLayer(null);
        }, [
            layersControl
        ]);
        const context = useMemo(()=>{
            return extendContext(parentContext, {
                layerContainer: {
                    addLayer,
                    removeLayer
                }
            });
        }, [
            parentContext,
            addLayer,
            removeLayer
        ]);
        useEffect(()=>{
            if (layer !== null && propsRef.current !== props) {
                if (props.checked === true && (propsRef.current.checked == null || propsRef.current.checked === false)) {
                    map.addLayer(layer);
                } else if (propsRef.current.checked === true && (props.checked == null || props.checked === false)) {
                    map.removeLayer(layer);
                }
                propsRef.current = props;
            }
        });
        return props.children ? React.createElement(LeafletProvider, {
            value: context
        }, props.children) : null;
    };
}
LeafletLayersControl.BaseLayer = createLeafletControlledLayer(function addBaseLayer(layersControl, layer, name) {
    layersControl.addBaseLayer(layer, name);
});
LeafletLayersControl.Overlay = createLeafletControlledLayer(function addOverlay(layersControl, layer, name) {
    layersControl.addOverlay(layer, name);
});
